import React from "react"

export const ActionReasonsContext = React.createContext({
	reasons: ["No Reason"],
})
